/* ======================================================================
 * BIOTEINE. JAVASCRIPT v4
 * assets/bioteine.js
 *
 * Vanilla JS. No frameworks. All interactions namespaced under BT.*
 * Defensive: every querySelector wrapped in if() to handle missing DOM
 * ====================================================================== */

(function() {
  'use strict';

  const BT = window.BT = window.BT || {};

  /* =====================================================
  GALLERY (PDP)
  ===================================================== */
  BT.initGallery = function(root) {
  const main = root.querySelector('.bt-gallery-main');
  const thumbs = root.querySelectorAll('.bt-thumb');
  const zoomBtn = root.querySelector('.bt-gallery-zoom');
  if (!main) return;

  // Build the ordered list of full-resolution URLs (1st = main, then thumbs)
  function gatherSrcs() {
  const list = [];
  if (main && main.src) list.push(main.src.replace(/&?width=\d+/, '&width=1600'));
  thumbs.forEach(t => {
  const f = (t.dataset.full || t.src || '').replace(/&?width=\d+/, '&width=1600');
  if (f && !list.includes(f)) list.push(f);
  });
  return list.length ? list : (main ? [main.src] : []);
  }

  thumbs.forEach(thumb => {
  thumb.addEventListener('click', () => {
  const fullSrc = thumb.dataset.full || thumb.src;
  main.style.opacity = '0.5';
  const img = new Image();
  img.onload = () => {
  main.src = fullSrc;
  main.style.opacity = '1';
  };
  img.src = fullSrc;
  thumbs.forEach(t => t.classList.remove('active'));
  thumb.classList.add('active');
  });
  thumb.addEventListener('keydown', (e) => {
  if (e.key === 'Enter' || e.key === ' ') {
  e.preventDefault();
  thumb.click();
  }
  });
  });

  // Click main image OR zoom button → lightbox
  function openLb() {
  if (BT.Lightbox && typeof BT.Lightbox.open === 'function') {
  BT.Lightbox.open(gatherSrcs(), 0);
  }
  }
  if (main) {
  main.style.cursor = 'zoom-in';
  main.addEventListener('click', openLb);
  }
  if (zoomBtn) {
  zoomBtn.addEventListener('click', (e) => { e.stopPropagation(); openLb(); });
  }
  };

  /* =====================================================
  LIGHTBOX
  ===================================================== */
  BT.Lightbox = {
  init() {
  this.el = document.querySelector('[data-bt-lightbox]');
  if (!this.el) return;
  this.img = this.el.querySelector('[data-bt-lb-img]');
  this.prevBtn = this.el.querySelector('[data-bt-lb-prev]');
  this.nextBtn = this.el.querySelector('[data-bt-lb-next]');
  this.closeBtn = this.el.querySelector('[data-bt-lb-close]');
  this.srcs = []; this.idx = 0;

  this.closeBtn?.addEventListener('click', () => this.close());
  this.el.addEventListener('click', (e) => { if (e.target === this.el) this.close(); });
  this.prevBtn?.addEventListener('click', (e) => { e.stopPropagation(); this.go(-1); });
  this.nextBtn?.addEventListener('click', (e) => { e.stopPropagation(); this.go(1); });
  document.addEventListener('keydown', (e) => {
  if (this.el.hidden) return;
  if (e.key === 'Escape') this.close();
  if (e.key === 'ArrowLeft') this.go(-1);
  if (e.key === 'ArrowRight') this.go(1);
  });
  },
  open(srcs, idx) {
  if (!this.el || !srcs || srcs.length === 0) return;
  this.srcs = srcs; this.idx = idx || 0;
  this.render();
  this.el.hidden = false;
  this.el.removeAttribute('hidden');
  requestAnimationFrame(() => this.el.classList.add('is-open'));
  this.el.setAttribute('aria-hidden', 'false');
  document.body.classList.add('bt-no-scroll');
  },
  close() {
  if (!this.el) return;
  this.el.classList.remove('is-open');
  this.el.setAttribute('aria-hidden', 'true');
  document.body.classList.remove('bt-no-scroll');
  setTimeout(() => { if (!this.el.classList.contains('is-open')) this.el.hidden = true; }, 200);
  },
  go(delta) {
  if (this.srcs.length <= 1) return;
  this.idx = (this.idx + delta + this.srcs.length) % this.srcs.length;
  this.render();
  },
  render() {
  if (this.img) this.img.src = this.srcs[this.idx] || '';
  const multi = this.srcs.length > 1;
  if (this.prevBtn) this.prevBtn.hidden = !multi;
  if (this.nextBtn) this.nextBtn.hidden = !multi;
  },
  };

  /* =====================================================
  QUICK-VIEW (cards + quick add)
  ===================================================== */
  BT.QuickView = {
  init() {
  this.el = document.querySelector('[data-bt-quickview-modal]');
  if (!this.el) return;
  this.titleEl = this.el.querySelector('[data-bt-qv-title]');
  this.priceEl = this.el.querySelector('[data-bt-qv-price]');
  this.imgEl = this.el.querySelector('[data-bt-qv-img]');
  this.linkEls = this.el.querySelectorAll('[data-bt-qv-link]');
  this.variantsEl = this.el.querySelector('[data-bt-qv-variants]');
  this.qtyInput = this.el.querySelector('[data-bt-qv-qty-input]');
  this.addBtn = this.el.querySelector('[data-bt-qv-add]');
  this.closers = this.el.querySelectorAll('[data-bt-qv-close]');
  this.currentVariantId = null;

  // Document-level: any [data-bt-quickview] triggers this
  document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-bt-quickview]');
  if (!btn) return;
  e.preventDefault();
  e.stopPropagation();
  this.openFromBtn(btn);
  });

  this.closers.forEach(c => c.addEventListener('click', () => this.close()));
  document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape' && !this.el.hidden) this.close();
  });

  // Qty stepper
  this.el.querySelector('[data-bt-qv-qty-decr]')?.addEventListener('click', () => this.bumpQty(-1));
  this.el.querySelector('[data-bt-qv-qty-incr]')?.addEventListener('click', () => this.bumpQty(1));

  // Add to cart
  this.addBtn?.addEventListener('click', () => this.add());
  },
  bumpQty(delta) {
  const v = parseInt(this.qtyInput.value || '1', 10);
  this.qtyInput.value = Math.max(1, Math.min(99, v + delta));
  },
  openFromBtn(btn) {
  const d = btn.dataset;
  this.currentVariantId = d.variantId;
  if (this.titleEl) this.titleEl.textContent = d.productTitle || '';
  if (this.priceEl) this.priceEl.textContent = d.productPrice || '';
  if (this.imgEl) {
  this.imgEl.src = d.productImage || '';
  this.imgEl.alt = d.productTitle || '';
  }
  this.linkEls.forEach(a => a.href = d.productUrl || '#');
  this.qtyInput.value = 1;
  this.addBtn.classList.remove('is-added','is-loading');
  const addSpan = this.addBtn.querySelector('span');
  if (addSpan) addSpan.textContent = this.addBtn.dataset.textAdd || 'Toevoegen aan winkelwagen';

  // If product has variants, fetch and render variant picker
  if (this.variantsEl) {
  this.variantsEl.hidden = true;
  this.variantsEl.innerHTML = '';
  }
  if (d.hasVariants === 'true' && d.productHandle) {
  fetch(`/products/${d.productHandle}.js`, { headers: { 'Accept': 'application/json' } })
  .then(r => r.json())
  .then(p => this.renderVariants(p))
  .catch(() => {/* silent. Qty-only ATC still works */});
  }

  this.el.hidden = false;
  this.el.removeAttribute('hidden');
  requestAnimationFrame(() => this.el.classList.add('is-open'));
  this.el.setAttribute('aria-hidden', 'false');
  document.body.classList.add('bt-no-scroll');
  },
  renderVariants(product) {
  if (!product || !product.variants || product.variants.length <= 1) return;
  this.variantsEl.hidden = false;
  const pills = product.variants.map(v => {
  const dis = v.available ? '' : ' is-disabled';
  const sel = String(v.id) === String(this.currentVariantId) ? ' is-active' : '';
  return `<button type="button" class="bt-qv__variant${sel}${dis}" data-vid="${v.id}" data-price="${BT.fmtPrice ? BT.fmtPrice(v.price) : v.price}"${v.available?'':' disabled'}>${this.escape(v.title)}</button>`;
  }).join('');
  this.variantsEl.innerHTML = `<span class="bt-qv__variants-label">Variant:</span>${pills}`;
  this.variantsEl.querySelectorAll('.bt-qv__variant').forEach(btn => {
  btn.addEventListener('click', () => {
  const v = product.variants.find(x => String(x.id) === btn.dataset.vid);
  if (!v) return;
  this.currentVariantId = v.id;
  this.variantsEl.querySelectorAll('.bt-qv__variant').forEach(x => x.classList.remove('is-active'));
  btn.classList.add('is-active');
  if (this.priceEl) {
  const cents = parseInt(v.price, 10);
  this.priceEl.textContent = '€' + (cents/100).toFixed(2).replace('.', ',');
  }
  });
  });
  },
  escape(s) {
  return String(s||'').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  },
  close() {
  this.el.classList.remove('is-open');
  this.el.setAttribute('aria-hidden', 'true');
  document.body.classList.remove('bt-no-scroll');
  setTimeout(() => { if (!this.el.classList.contains('is-open')) this.el.hidden = true; }, 200);
  },
  async add() {
  if (!this.currentVariantId) return;
  const qty = parseInt(this.qtyInput.value || '1', 10) || 1;
  const span = this.addBtn.querySelector('span');
  this.addBtn.classList.add('is-loading');
  if (span) span.textContent = 'Bezig…';
  try {
  if (BT.CartDrawer && typeof BT.CartDrawer.addItem === 'function') {
  await BT.CartDrawer.addItem(this.currentVariantId, qty);
  } else {
  await fetch('/cart/add.js', {
  method: 'POST',
  headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
  body: JSON.stringify({ id: this.currentVariantId, quantity: qty }),
  });
  }
  this.addBtn.classList.remove('is-loading');
  this.addBtn.classList.add('is-added');
  if (span) span.textContent = 'Toegevoegd';
  setTimeout(() => this.close(), 900);
  } catch (e) {
  this.addBtn.classList.remove('is-loading');
  if (span) span.textContent = 'Mislukt';
  }
  },
  };

  /* =====================================================
  VARIANT PICKER (pills + volume cards)
  Reads data-variant-id on each pill / card
  Updates price, compare-at, and the hidden form input
  ===================================================== */
  BT.initVariantPicker = function(root, productJson) {
  const form = root.querySelector('[data-product-form]');
  const variantInput = form?.querySelector('[name="id"]');
  const priceEl = root.querySelector('[data-price-current]');
  const compareEl = root.querySelector('[data-price-compare]');
  const saveEl = root.querySelector('[data-price-save]');
  const priceSub = root.querySelector('[data-price-sub]');
  const perEl = root.querySelector('[data-price-per]');
  let perMap = {};
  const perMapEl = root.querySelector('[data-portions-map]');
  if (perMapEl) { try { perMap = JSON.parse(perMapEl.textContent); } catch(e) {} }
  const stickyPrice = document.querySelector('[data-sticky-price]');
  const stickyAtc = document.querySelector('[data-sticky-atc]');
  const atcBtn = root.querySelector('[data-atc-btn]');

  const variants = productJson?.variants || [];
  if (variants.length === 0) return;

  function formatPrice(cents, currency) {
  const amt = (cents / 100).toLocaleString('nl-NL', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return '€' + amt;
  }

  function selectVariant(variantId) {
  const variant = variants.find(v => String(v.id) === String(variantId));
  if (!variant) return;

  if (variantInput) variantInput.value = variant.id;
  if (priceEl) priceEl.textContent = formatPrice(variant.price);
  if (compareEl) {
  if (variant.compare_at_price && variant.compare_at_price > variant.price) {
  compareEl.textContent = formatPrice(variant.compare_at_price);
  compareEl.style.display = '';
  const pct = Math.round((1 - variant.price / variant.compare_at_price) * 100);
  if (saveEl) {
  saveEl.textContent = 'Bespaar ' + pct + '%';
  saveEl.style.display = '';
  }
  } else {
  compareEl.style.display = 'none';
  if (saveEl) saveEl.style.display = 'none';
  }
  }
  if (stickyPrice) stickyPrice.textContent = formatPrice(variant.price);
  if (perEl) {
  const per = perMap[String(variant.id)] || 0;
  if (per > 0) { perEl.textContent = formatPrice(per) + ' per portie'; perEl.style.display = ''; }
  else { perEl.style.display = 'none'; }
  }
  if (atcBtn) {
  if (variant.available) {
  atcBtn.disabled = false;
  atcBtn.querySelector('span').textContent = atcBtn.dataset.textAvailable || 'Toevoegen aan winkelwagen';
  } else {
  atcBtn.disabled = true;
  atcBtn.querySelector('span').textContent = atcBtn.dataset.textUnavailable || 'Uitverkocht';
  }
  }

  // Update URL ?variant=
  try {
  const url = new URL(window.location);
  url.searchParams.set('variant', variant.id);
  window.history.replaceState({}, '', url);
  } catch(e) {}
  }

  // Hook up pills (single option) and volume cards
  root.querySelectorAll('[data-variant-id]').forEach(el => {
  el.addEventListener('click', () => {
  const group = el.closest('[data-picker-group]');
  if (group) {
  group.querySelectorAll('[data-variant-id]').forEach(s => s.classList.remove('selected'));
  }
  el.classList.add('selected');
  selectVariant(el.dataset.variantId);
  });
  });
  };

  /* =====================================================
  SUBSCRIPTION TOGGLE
  ===================================================== */
  BT.initSubscribe = function(root) {
  const opts = root.querySelectorAll('[data-sub-option]');
  if (opts.length === 0) return;
  const sellingPlanInput = root.querySelector('[name="selling_plan"]');
  const subscribeBlock = root.querySelector('[data-subscribe-block]');
  const expand = root.querySelector('[data-subscribe-expand]');
  const subscribePrice = root.querySelector('[data-subscribe-price]');
  const onetimePrice = root.querySelector('[data-onetime-price]');
  const onetimePriceCents = onetimePriceFromDom();

  function onetimePriceFromDom() {
  // Pull current product price in cents from the main price block (data-attribute or text)
  const priceEl = document.querySelector('[data-price-current]') || document.querySelector('[data-price]') || root.querySelector('[data-onetime-price]');
  if (!priceEl) return null;
  const raw = priceEl.textContent.trim().replace(/[^\d,\.]/g, '').replace(',', '.');
  const num = parseFloat(raw);
  return isNaN(num) ? null : Math.round(num * 100);
  }

  function formatPrice(cents) {
  if (cents === null || isNaN(cents)) return '';
  return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function computeSubscribePrice(planId) {
  // Map plan id → discount % from radio attributes (expand hosts the freq inputs)
  if (!expand) return null;
  const freqOpt = expand.querySelector('input[data-freq-input][value="' + planId + '"]');
  if (!freqOpt) return null;
  const live = onetimePriceFromDom();
  const save = freqOpt.closest('.bt-purchase__freq-option').querySelector('.bt-purchase__freq-save');
  if (!save) return live;
  const pct = parseInt(save.textContent.replace(/[^\d]/g, ''), 10);
  if (isNaN(pct) || !live) return live;
  return Math.round(live * (100 - pct) / 100);
  }

  // Top-level: switch between onetime and subscribe modes
  opts.forEach(opt => {
  opt.addEventListener('click', (e) => {
  opts.forEach(o => {
  o.classList.remove('selected');
  const outer = o.closest('.bt-purchase__option');
  if (outer) outer.classList.remove('selected');
  });
  // The clicked element is either the .bt-purchase__option--onetime button
  // OR the .bt-purchase__option-trigger inside the subscribe block.
  // For visual "selected" state we mark the OUTER option element.
  const outerOption = opt.closest('.bt-purchase__option') || opt;
  outerOption.classList.add('selected');

  const planId = opt.dataset.sellingPlanId || '';
  if (sellingPlanInput) sellingPlanInput.value = planId;

  // Subscribe mode: expand the panel + show subscribe price
  if (planId && expand) {
  expand.hidden = false;
  // Sync frequency selection with the planId
  const targetFreq = expand.querySelector('input[data-freq-input][value="' + planId + '"]');
  if (targetFreq) targetFreq.checked = true;
  updateFreqSelectedClass();
  if (subscribePrice) subscribePrice.textContent = formatPrice(computeSubscribePrice(planId));
  } else if (expand) {
  // One-time mode: collapse the expand panel
  expand.hidden = true;
  }
  });
  });

  // Frequency radio change: update selling_plan + subscribe price + selected class
  function updateFreqSelectedClass() {
  if (!expand) return;
  expand.querySelectorAll('.bt-purchase__freq-option').forEach(opt => {
  const input = opt.querySelector('input[data-freq-input]');
  if (input && input.checked) opt.classList.add('selected');
  else opt.classList.remove('selected');
  });
  }
  if (expand) {
  expand.querySelectorAll('input[data-freq-input]').forEach(input => {
  input.addEventListener('change', () => {
  updateFreqSelectedClass();
  const planId = input.value;
  if (sellingPlanInput) sellingPlanInput.value = planId;
  // Also update the trigger's data attribute so re-clicks pick the same plan
  const trigger = subscribeBlock.querySelector('[data-sub-option]');
  if (trigger) trigger.dataset.sellingPlanId = planId;
  if (subscribePrice) subscribePrice.textContent = formatPrice(computeSubscribePrice(planId));
  });
  });
  }

  // Prijzen in de 50/50-kaarten synchroon houden met de gekozen variant.
  // De variantpicker schrijft de hoofdprijs in [data-price-current]; we volgen
  // dat element met een MutationObserver zodat elke formaat-wissel beide
  // kaarten (eenmalig + abonneer) bijwerkt, onafhankelijk van de picker-code.
  function syncPurchasePrices() {
  const live = onetimePriceFromDom();
  if (onetimePrice && live) onetimePrice.textContent = formatPrice(live);
  if (subscribeBlock && subscribePrice) {
  const trigger = subscribeBlock.querySelector('[data-sub-option]');
  const pid = trigger ? trigger.dataset.sellingPlanId : '';
  if (pid) subscribePrice.textContent = formatPrice(computeSubscribePrice(pid));
  }
  }
  const mainPriceEl = document.querySelector('[data-price-current]');
  if (mainPriceEl && 'MutationObserver' in window) {
  new MutationObserver(syncPurchasePrices).observe(mainPriceEl, { childList: true, characterData: true, subtree: true });
  }
  syncPurchasePrices();
  };

  /* =====================================================
  ACCORDIONS
  ===================================================== */
  BT.initAccordions = function(root) {
  root.querySelectorAll('.bt-accord-header').forEach(header => {
  header.addEventListener('click', () => {
  const body = header.nextElementSibling;
  const isOpen = header.classList.contains('open');
  if (isOpen) {
  header.classList.remove('open');
  if (body) body.classList.remove('open');
  header.setAttribute('aria-expanded', 'false');
  } else {
  header.classList.add('open');
  if (body) body.classList.add('open');
  header.setAttribute('aria-expanded', 'true');
  }
  });
  });
  };

  /* =====================================================
  TABS (PDP below-fold)
  ===================================================== */
  BT.initTabs = function(root) {
  const tabs = root.querySelectorAll('.bt-tab');
  const panels = root.querySelectorAll('.bt-tab-panel');
  tabs.forEach(tab => {
  tab.addEventListener('click', () => {
  const target = tab.dataset.tab;
  tabs.forEach(t => t.classList.remove('active'));
  panels.forEach(p => p.classList.remove('active'));
  tab.classList.add('active');
  const panel = root.querySelector('#tab-' + target);
  if (panel) panel.classList.add('active');
  });
  });
  };

  /* =====================================================
  WISHLIST (localStorage)
  ===================================================== */
  const HEART_OUTLINE = '<svg class="bt-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.4 5.6a5 5 0 00-7-.4L12 6.4l-1.4-1.2a5 5 0 00-7 7.2L12 21l8.4-8.6a5 5 0 000-6.8z"/></svg>';
  const HEART_FILL = '<svg class="bt-icon" width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M20.4 5.6a5 5 0 00-7-.4L12 6.4l-1.4-1.2a5 5 0 00-7 7.2L12 21l8.4-8.6a5 5 0 000-6.8z"/></svg>';

  function btWishCount() {
  try { return JSON.parse(localStorage.getItem('bt_wishlist') || '[]').length; } catch(e) { return 0; }
  }
  function btUpdateWishBadge() {
  const badge = document.querySelector('[data-bt-wish-count]');
  if (!badge) return;
  const n = btWishCount();
  if (n > 0) {
  badge.textContent = String(n);
  badge.hidden = false;
  badge.removeAttribute('hidden');
  } else {
  badge.hidden = true;
  badge.setAttribute('hidden', '');
  }
  }
  BT.updateWishBadge = btUpdateWishBadge;

  BT.initWishlist = function() {
  btUpdateWishBadge();
  document.querySelectorAll('[data-wish-toggle]').forEach(btn => {
  const handle = btn.dataset.handle;
  try {
  const list = JSON.parse(localStorage.getItem('bt_wishlist') || '[]');
  if (list.includes(handle)) {
  btn.classList.add('active');
  btn.innerHTML = HEART_FILL;
  }
  } catch(e) {}
  btn.addEventListener('click', () => {
  let list = [];
  try { list = JSON.parse(localStorage.getItem('bt_wishlist') || '[]'); } catch(e) {}
  if (list.includes(handle)) {
  list = list.filter(h => h !== handle);
  btn.classList.remove('active');
  btn.innerHTML = HEART_OUTLINE;
  } else {
  list.push(handle);
  btn.classList.add('active');
  btn.innerHTML = HEART_FILL;
  }
  try { localStorage.setItem('bt_wishlist', JSON.stringify(list)); } catch(e) {}
  btUpdateWishBadge();
  });
  });
  };

  /* =====================================================
  SOCIAL PROOF ROTATOR
  ===================================================== */
  BT.initSocialProof = function(root) {
  const el = root.querySelector('[data-social-proof]');
  if (!el) return;
  const raw = el.dataset.proofs || '';
  const proofs = raw.split('||').map(s => s.trim()).filter(Boolean);
  if (proofs.length === 0) return;
  let idx = 0;
  const textEl = el.querySelector('[data-social-proof-text]');
  if (!textEl) return;
  setInterval(() => {
  idx = (idx + 1) % proofs.length;
  el.style.opacity = '0';
  setTimeout(() => {
  textEl.textContent = proofs[idx];
  el.style.opacity = '1';
  }, 300);
  }, 4500);
  };

  /* =====================================================
  STICKY BAR (PDP mobile). auto hide/show on scroll
  ===================================================== */
  BT.initStickyBar = function() {
  const bar = document.querySelector('.bt-sticky-bar');
  const progress = document.querySelector('.bt-sticky-progress');
  const atc = document.querySelector('[data-atc-btn]');
  if (!bar || !atc) return;
  function update() {
  const rect = atc.getBoundingClientRect();
  const visible = rect.bottom > 0 && rect.top < window.innerHeight;
  if (visible) {
  bar.style.display = 'none';
  if (progress) progress.style.display = 'none';
  } else if (window.innerWidth <= 900) {
  bar.style.display = 'flex';
  if (progress) progress.style.display = 'block';
  }
  }
  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
  update();
  };

  /* =====================================================
  ATC. Shopify cart/add.js
  ===================================================== */
  BT.initAddToCart = function() {
  document.querySelectorAll('[data-product-form]').forEach(form => {
  form.addEventListener('submit', async (e) => {
  e.preventDefault();
  const btn = form.querySelector('[data-atc-btn]');
  const original = btn?.querySelector('span')?.textContent;
  if (btn) {
  btn.classList.add('added');
  if (btn.querySelector('span')) btn.querySelector('span').textContent = 'Toevoegen…';
  }
  try {
  const fd = new FormData(form);
  const res = await fetch('/cart/add.js', {
  method: 'POST',
  body: fd,
  headers: { 'Accept': 'application/json' }
  });
  if (!res.ok) throw new Error('Add to cart failed');
  await res.json();
  // Update cart count
  const cartRes = await fetch('/cart.js');
  const cart = await cartRes.json();
  document.querySelectorAll('[data-cart-count]').forEach(el => {
  el.textContent = cart.item_count;
  });
  if (btn?.querySelector('span')) btn.querySelector('span').textContent = 'Toegevoegd';
  setTimeout(() => {
  if (btn) {
  btn.classList.remove('added');
  if (btn.querySelector('span')) btn.querySelector('span').textContent = original || 'Toevoegen aan winkelwagen';
  }
  }, 1800);
  } catch(err) {
  console.error(err);
  if (btn?.querySelector('span')) btn.querySelector('span').textContent = 'Mislukt. Probeer opnieuw';
  }
  });
  });
  };

  /* =====================================================
  MOBILE DRAWER
  ===================================================== */
  /* =====================================================
  MEGA MENU. Hover-intent with close delay so user can move
  to the panel without it collapsing.
  ===================================================== */
  BT.initMegaMenu = function() {
  var wraps = document.querySelectorAll('[data-bt-mega-wrap]');
  if (!wraps.length) return;
  var CLOSE_DELAY = 250; // ms

  wraps.forEach(function(wrap){
  var trigger = wrap.querySelector('[data-bt-mega-trigger]');
  var panel = wrap.querySelector('.bt-header__mega');
  if (!trigger || !panel) return;

  var closeTimer = null;
  function open(){
  if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
  wrap.classList.add('is-open');
  trigger.setAttribute('aria-expanded', 'true');
  }
  function scheduleClose(){
  if (closeTimer) clearTimeout(closeTimer);
  closeTimer = setTimeout(function(){
  wrap.classList.remove('is-open');
  trigger.setAttribute('aria-expanded', 'false');
  }, CLOSE_DELAY);
  }

  wrap.addEventListener('mouseenter', open);
  wrap.addEventListener('mouseleave', scheduleClose);
  // Cancel close if user moves over the panel quickly
  panel.addEventListener('mouseenter', open);

  // Click on trigger toggles (for touch devices)
  trigger.addEventListener('click', function(e){
  // On desktop with mouse, prefer click-to-navigate. On touch, prefer toggle.
  if (window.matchMedia('(hover: hover)').matches) return;
  e.preventDefault();
  if (wrap.classList.contains('is-open')) {
  wrap.classList.remove('is-open');
  trigger.setAttribute('aria-expanded', 'false');
  } else {
  open();
  }
  });
  });

  // Close any open mega when clicking outside
  document.addEventListener('click', function(e){
  var insideMega = e.target.closest('[data-bt-mega-wrap]');
  if (!insideMega) {
  wraps.forEach(function(w){
  w.classList.remove('is-open');
  var t = w.querySelector('[data-bt-mega-trigger]');
  if (t) t.setAttribute('aria-expanded', 'false');
  });
  }
  });
  };

  BT.initDrawer = function() {
  const drawer = document.querySelector('[data-bt-drawer]');
  if (!drawer) return;
  const openTriggers = document.querySelectorAll('[data-bt-drawer-open], .bt-header__burger');
  const closeTriggers = document.querySelectorAll('[data-bt-drawer-close]');

  function openDrawer() {
  drawer.hidden = false;
  drawer.removeAttribute('hidden');
  // Force reflow before adding class so CSS transitions can run
  void drawer.offsetWidth;
  drawer.classList.add('is-open');
  drawer.setAttribute('aria-hidden', 'false');
  document.body.classList.add('bt-no-scroll');
  }
  function closeDrawer() {
  drawer.classList.remove('is-open');
  drawer.setAttribute('aria-hidden', 'true');
  document.body.classList.remove('bt-no-scroll');
  // Re-hide after transition to keep it out of the AT tree
  setTimeout(function(){
  if (!drawer.classList.contains('is-open')) drawer.setAttribute('hidden', '');
  }, 300);
  }

  openTriggers.forEach(function(t){ t.addEventListener('click', function(e){ e.preventDefault(); openDrawer(); }); });
  closeTriggers.forEach(function(t){ t.addEventListener('click', function(e){ e.preventDefault(); closeDrawer(); }); });
  document.addEventListener('keydown', function(e){
  if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
  });
  };

  /* =====================================================
  INIT
  ===================================================== */
  document.addEventListener('DOMContentLoaded', () => {
  BT.initMegaMenu();
  BT.initDrawer();
  BT.initWishlist();
  // BT.initAddToCart() is now handled by bioteine-cart.js (which patches it)
  BT.initStickyBar();

  BT.Lightbox.init();
  BT.QuickView.init();

  // Judge.me sniff: when their script loads and populates a widget, flag the body.
  (function() {
  function check() {
  var hydrated = !!document.querySelector('.jdgm-preview-badge .jdgm-rev-widg, .jdgm-prev-badge__stars, .jdgm-rev-widg__reviews');
  if (hydrated) document.body.classList.add('has-judgeme');
  }
  check();
  // Re-check a few times after page load. Judge.me hydrates async
  [800, 2500, 5000].forEach(function(t) { setTimeout(check, t); });
  })();
  document.querySelectorAll('[data-bt-gallery]').forEach(el => BT.initGallery(el));
  document.querySelectorAll('[data-bt-subscribe]').forEach(el => BT.initSubscribe(el));
  document.querySelectorAll('[data-bt-accordions]').forEach(el => BT.initAccordions(el));
  document.querySelectorAll('[data-bt-tabs]').forEach(el => BT.initTabs(el));
  document.querySelectorAll('[data-bt-social-proof]').forEach(el => BT.initSocialProof(el));

  // Variant pickers need product json in window
  document.querySelectorAll('[data-bt-variants]').forEach(el => {
  const jsonId = el.dataset.btVariants;
  const dataEl = document.getElementById(jsonId);
  if (dataEl) {
  try {
  const productJson = JSON.parse(dataEl.textContent);
  BT.initVariantPicker(el, productJson);
  } catch(e) { console.error('Variant JSON parse failed', e); }
  }
  });
  });

})();
